import { createFileRoute } from "@tanstack/react-router";
import { MediaGallery } from "@/components/media/media-gallery";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/media")({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectSlug } = Route.useParams();
  return <MediaGallery projectSlug={projectSlug} />;
}
